import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { userPrivileges } from '../../../apollo/cache';
import { useReactiveVar } from '@apollo/client';
import PrivilegeNames from '../../../constants/privilegeNames';
import NotFoundPage from '../../notFound/NotfoundPage';
import ReleaseNotesPage from '../../releaseNotes/components/ReleaseNotesPage';
import ResourcePage from '../../resources/components/ResourcesPage';
import SubmitFeedbackPage from '../../feedback/components/SubmitFeedbackPage';
import NoPermissionsPage from '../../unauthorized/NoPermissionsPage.js';
import LandingPageWrapper from '../components/LandingPageWrapper';
import InvoicesPage from '../../invoices/components/Invoices';

const RoutesForFreeLicense = () => {
  const privileges = useReactiveVar(userPrivileges);
  if (!privileges?.length) {
    return null;
  }

  return (
    <Routes>
      {privileges.includes(PrivilegeNames.Invoices) && (
        <Route path='/invoices' element={<InvoicesPage />} />
      )}

      {privileges.includes(PrivilegeNames.Resources) && (
        <Route path='/resources' element={<LandingPageWrapper page={ResourcePage} />} />
      )}
      {privileges.includes(PrivilegeNames.ReleaseNotes) && (
        <Route path='/release-notes' element={<ReleaseNotesPage />} />
      )}
      {privileges.includes(PrivilegeNames.SubmitFeedback) && (
        <Route path='/submit-feedback' element={<SubmitFeedbackPage />} />
      )}
      <Route path='/' element={<Navigate to='/resources' replace />} />
      <Route path='/page-not-found' element={<NotFoundPage />} />

      <Route path='/permissions' element={<NoPermissionsPage />} />
      <Route path='*' element={<Navigate to='/page-not-found' replace />} />
    </Routes>
  );
};

export default RoutesForFreeLicense;
